import rawData_home_loggedOut from './scripts/homePage_LoggedOutScript'



const data = () => {
    const rawData = rawData_home_loggedOut
    let addNewTypewriterProp = false;
    let typewriter = 1;

    let isRenegadeOS = false;
    let number = 1;
    const finishedData = rawData.map(chunk => {
        chunk.typewriter = typewriter
        if (chunk.endTypewriterBlock !== undefined && chunk.endTypewriterBlock === true) {
            addNewTypewriterProp = true;
            typewriter++;
        }
        chunk.isNewTypewriter = addNewTypewriterProp
        addNewTypewriterProp = false;

        //Add in a flag to know which modules are part of Ren OS for the progress bar
        if (chunk.startRenegadeOS) {
            isRenegadeOS = true
        }
        chunk.isRenegadeOS = isRenegadeOS

        chunk.number = number
        number = number + 1

        return chunk
    })

    return finishedData
}

export default data;
